import isEmpty from "lodash/isEmpty";

// Utils
import { deserializeMeetingList, deserializeMeeting } from "@/utils/deserializers/meetings-deserializer";
import { fetchMeetings } from "@/api";

// Constants
export const INITIALIZE_MEETINGS = "INITIALIZE_MEETINGS";
export const MEETINGS_LOADING = "MEETINGS_LOADING";
export const OPEN_MEETING_MODAL = "OPEN_MEETING_MODAL";
export const OPEN_MEETING_INFO_MODAL = "OPEN_MEETING_INFO_MODAL";
export const COUNSELLOR_MEETING_DATA = "COUNSELLOR_MEETING_DATA";

// Utils
export const initializeMeetings = (payload) => {
    return {
        type: INITIALIZE_MEETINGS,
        payload,
    };
};
export const meetingsLoading = (payload) => {
    return {
        type: MEETINGS_LOADING,
        payload,
    };
};
export const initializeCounsellorMeetings = (payload) => {
    return {
        type: COUNSELLOR_MEETING_DATA,
        payload,
    };
};

export const meetingsGetAndStore = (data) => {
    return (dispatch) => {
        dispatch(meetingsLoading(true));
        fetchMeetings(data)
            .then((res) => {
                const deserializedMeetingList = deserializeMeetingList(res.data);
                dispatch(initializeMeetings(deserializedMeetingList));
            })
            .catch((err) => {
                console.error(err);
                dispatch(initializeMeetings([]));
            });
    };
};

export const meetingsOfCounsellor = (data) => {
    return (dispatch) => {
        dispatch({ type: COUNSELLOR_MEETING_DATA, payload: [] });
        fetchMeetings(data)
            .then((res) => {
                const deserializedMeetingList = deserializeMeetingList(res.data);
                dispatch(initializeCounsellorMeetings(deserializedMeetingList));
            })
            .catch((err) => {
                console.error(err);
                dispatch(initializeCounsellorMeetings([]));
            });
    };
};

export const updateMeetingInStore = (data) => {
    return (dispatch, getState) => {
        if (isEmpty(data)) {
            return;
        }

        const meetData = deserializeMeeting(data);
        const meetingState = getState().meetings;
        const userMeets = [...meetingState.data];
        const counsellorMeets = [...meetingState.counsellorMeetings];

        const userMeetIndex = userMeets.findIndex((meet) => meet.id === meetData.id);
        const counsellorMeetIndex = counsellorMeets.findIndex((meet) => meet.id === meetData.id);

        if (userMeetIndex !== -1) {
            userMeets[userMeetIndex] = meetData;
        } else {
            userMeets.push(meetData);
        }

        if (counsellorMeetIndex !== -1) {
            counsellorMeets[counsellorMeetIndex] = meetData;
        } else {
            counsellorMeets.push(meetData);
        }

        dispatch(initializeMeetings(userMeets));
        dispatch(initializeCounsellorMeetings(counsellorMeets));
    };
};
